import React from 'react';
import { Redirect, Route, Switch, withRouter } from 'react-router-dom';

import Dashboard from './Dashboard';
import Calendar from './Calendar';
import Trans from './Trans';
import TransactionDetail from './TransactionDetail';
import ReportInvoice from './ReportInvoice';
import ReportInvoiceFull from './ReportInvoiceFull';
import Refund from './Refund';
import CheckPayout from './CheckPayout';
import ApprovePayout from './ApprovePayout';
import ReportPayout from './ReportPayout';
import ReportPayment from './ReportPayment';
import ReportPaymentGeneral from './ReportPaymentGeneral';
import Merchant from './Merchant';
import MerchantPerformance from './MerchantPerformance';
import AuditLog from './AuditLog';
import CekgudangCompanies from './CekgudangCompanies';
import SlaAging from './SlaAging';
import ExecutiveReport from './ExecutiveReport';
import UserAccess from './UserAccess';
import { canAccessRoute, isSuperAdmin } from '../utils/accessControl';

const fourtOFour = () => <section className="ops-page"><div className="ops-state"><i className="fas fa-map-signs" /><h3>Halaman tidak ditemukan</h3><p>Alamat yang Anda buka tidak tersedia di SPIN Management Portal.</p></div></section>
const forbidden = () => <section className="ops-page"><div className="ops-state"><i className="fas fa-user-lock" /><h3>Akses tidak tersedia</h3><p>User Anda tidak memiliki akses ke menu ini.</p></div></section>
const AccessRoute = ({ accessRoute, superAdminOnly, component: Component, render, ...props }) => (
  <Route {...props} render={routeProps => {
    const allowed = superAdminOnly ? isSuperAdmin() : canAccessRoute(accessRoute);
    if (!allowed) return forbidden();
    return render ? render(routeProps) : <Component {...routeProps} />;
  }} />
);

class Routes extends React.Component {
  render() {
    const platformKey = this.props.location.pathname.indexOf('/bursa-kopi/') === 0
      ? 'bursa-kopi'
      : 'ecommerce';
    const bursaProps = {
      apiPrefix: 'bursa-kopi/',
      detailBasePath: '/bursa-kopi/transactiondetail',
      domainSuffix: 'bursakopi.com',
    };

    return (
      <Switch key={platformKey}>
        <AccessRoute path='/dashboard' exact accessRoute='/dashboard' component={Dashboard} />
        <AccessRoute path='/sla-aging' exact accessRoute='/sla-aging' component={SlaAging} />
        <AccessRoute path='/executive-report' exact accessRoute='/executive-report' component={ExecutiveReport} />
        <AccessRoute path='/merchant' exact accessRoute='/merchant' component={Merchant} />
        <AccessRoute path='/merchant/performance' exact accessRoute='/merchant/performance' component={MerchantPerformance} />
        <AccessRoute path='/audit-log' exact accessRoute='/audit-log' component={AuditLog} />
        <AccessRoute path='/user-access' exact accessRoute='/user-access' superAdminOnly component={UserAccess} />
        <AccessRoute path='/cekgudang/companies' exact accessRoute='/cekgudang/companies' component={CekgudangCompanies} />
        <Redirect from='/transaction_1' exact to='/transaction' />
        <AccessRoute path='/transaction' exact accessRoute='/transaction' component={Trans} />
        <AccessRoute path='/transactiondetail/:invoiceId' exact accessRoute='/transaction' component={TransactionDetail} />
        <AccessRoute path='/reportinvoice' exact accessRoute='/reportinvoice' component={ReportInvoice} />
        <AccessRoute path='/reportinvoicefull' exact accessRoute='/reportinvoicefull' component={ReportInvoiceFull} />
        <AccessRoute path='/refund' exact accessRoute='/refund' component={Refund} />
        <AccessRoute path='/checkpayout' exact accessRoute='/checkpayout' component={CheckPayout} />
        <AccessRoute path='/approvepayout' exact accessRoute='/approvepayout' component={ApprovePayout} />
        <AccessRoute path='/reportpayout' exact accessRoute='/reportpayout' component={ReportPayout} />
        <AccessRoute path='/reportpembayaran' exact accessRoute='/reportpembayaran' component={ReportPayment} />
        <AccessRoute path='/reportpembayaran-general' exact accessRoute='/reportpembayaran-general' component={ReportPaymentGeneral} />
        <AccessRoute path='/reportpembayaran-general/detail/:invoiceId' exact accessRoute='/reportpembayaran-general' render={props => <TransactionDetail {...props} invoiceEndpoint="report/payment-general/invoice" />} />
        <AccessRoute path='/bursa-kopi/merchant' exact accessRoute='/bursa-kopi/merchant' render={props => <Merchant {...props} {...bursaProps} />} />
        <AccessRoute path='/bursa-kopi/merchant/performance' exact accessRoute='/bursa-kopi/merchant/performance' render={props => <MerchantPerformance {...props} {...bursaProps} />} />
        <AccessRoute path='/bursa-kopi/transaction' exact accessRoute='/bursa-kopi/transaction' render={props => <Trans {...props} {...bursaProps} />} />
        <AccessRoute path='/bursa-kopi/transactiondetail/:invoiceId' exact accessRoute='/bursa-kopi/transaction' render={props => <TransactionDetail {...props} {...bursaProps} />} />
        <AccessRoute path='/bursa-kopi/reportinvoice' exact accessRoute='/bursa-kopi/reportinvoice' render={props => <ReportInvoice {...props} {...bursaProps} />} />
        <AccessRoute path='/bursa-kopi/reportinvoicefull' exact accessRoute='/bursa-kopi/reportinvoicefull' render={props => <ReportInvoiceFull {...props} {...bursaProps} />} />
        <AccessRoute path='/bursa-kopi/refund' exact accessRoute='/bursa-kopi/refund' render={props => <Refund {...props} {...bursaProps} />} />
        <AccessRoute path='/bursa-kopi/checkpayout' exact accessRoute='/bursa-kopi/checkpayout' render={props => <CheckPayout {...props} {...bursaProps} />} />
        <AccessRoute path='/bursa-kopi/approvepayout' exact accessRoute='/bursa-kopi/approvepayout' render={props => <ApprovePayout {...props} {...bursaProps} />} />
        <AccessRoute path='/bursa-kopi/reportpayout' exact accessRoute='/bursa-kopi/reportpayout' render={props => <ReportPayout {...props} {...bursaProps} />} />
        <Route path='/calendar' exact component={Calendar} />

        {/* <Route path='/transaction' exact component={Transaction} /> */}
        <Route component={fourtOFour} />
      </Switch>
    );
  }
}

export default withRouter(Routes);
